(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		GamePanel = include('CountMeToSheep.GamePanel'),
		Delay = include('springroll.DelayedCall');

	/**
	 * The logic for the title state
	 * @class CountMeToSheep.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var GameState = function(options)
	{
		BaseState.call(this, new GamePanel(), options);

		this.startTimeout = this.startTimeout.bind(this);
		this.stopTimeout = this.stopTimeout.bind(this);
		this.startGame = this.startGame.bind(this);
	};

	//Extend the base state
	var p = extend(GameState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.state = this;
		app.config.globalState.mostRecentScreen = "Sheep Counting Screen";

		this.character = Math.floor(Math.random() * 3);
		this.time = 10000;

		var tellySpeak = function() {
			this.panel.tellySymbol.cursor = "CursorDefault";
			if (this.panel.waiting) {
				app.animator.play(this.panel.tellySymbol, 
					[{anim: "timeout2", audio: "Countsheep_24_Telly"}, "idle"]);
			}
		}.bind(this);

		var setup = function() {
			
		}.bind(this);

		this.timeoutStartTime = -1;
		this.autoTimeout = true;

		this.panel.launchButton.on('mouseover', this.cursorChange, this, false, this.panel.launchButton);
		this.panel.launchButton.on('mousedown', function() {
			if (this.timeoutStartTime > 0) {
				var duration = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000) - this.timeoutStartTime;
				GTM_obj.trackGTMEvent('gameTOReEngage', {'duration' : duration});
				this.timeoutStartTime = -1;
			}
			this.panel.loadLauncher();
		}.bind(this));
		this.panel.launchButton.on('pressup', this.panel.launchSheep, this);

		var skipStart = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000);
		this.panel.skipArea.on('mouseover', this.cursorChange, this, false, this.panel.skipArea);
		this.panel.skipArea.on('click', function() {
			var skipEnd = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000) - skipStart;
			GTM_obj.trackGTMEvent('gameSkip', {'duration' : skipEnd});
			this.startGame(); 
		}.bind(this));

		// this.panel.tellySymbol.on('mouseover', this.cursorChange, this, false, this.panel.tellySymbol);
		// this.panel.tellySymbol.on('click', tellySpeak, this);

		//Starts intro

		var callback = function() {
			app.animator.play(this.panel.countSetupSymbol, [
				{anim: "goal", audio: "Countsheep_12"}, 
				{anim: "thunder", audio: "thunder"}
			], this.startGame);
		}.bind(this);

		app.animator.play(this.panel.countSetupSymbol, this.panel.countAnimations.intro, callback);
		app.voPlayer.play("music");

	};

	p.startGame = function() {
		this.panel.startGame();
		this.clickCount();
		this.componentStart = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000);
		GTM_obj.trackGTMEvent('gameComponentStart', {'componentType' : 'Simulation', 'componentName' : 'Counting'});
	};

	p.cursorChange = function(event, symbol) {
		if (this.panel.waiting || symbol == this.panel.skipArea) {
			symbol.cursor = "pointer";
		} else {
			symbol.cursor = "CursorDefault";
		}
	};

	p.countSpeak = function() {
		if (this.timeoutStartTime > 0) {
			var duration = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000) - this.timeoutStartTime;
			GTM_obj.trackGTMEvent('gameTOReEngage', {'duration' : duration});
			this.timeoutStartTime = -1;
		}
		this.panel.countSymbol.cursor = "CursorDefault";
		this.autoTimeout = false;
		if (this.panel.waiting) {
			this.stopTimeout();
			this.time = 200;
			this.character = 1;
			this.startTimeout();
		}
	};

	p.clickCount = function() {
		this.panel.countSymbol.on('mouseover', this.cursorChange, this, false, this.panel.countSymbol);
		this.panel.countSymbol.on('click', this.countSpeak, this);
	};

	//Handles timeouts during gameplay
	p.startTimeout = function(resetCount) {
		if (typeof resetCount === "undefined") {
			resetCount = true;
		}
		if (this.timeout) {
			this.timeout.destroy();
		}
		this.timeout = new Delay((function(){
			if (app.voPlayer.playing || !this.panel.waiting) {
				// don't interrupt playing VO
				this.startTimeout(true);
				return;
			}

			var voList = [];
			var callback = function() {
				if (this.panel.waiting) {
					this.panel.initializeCount("main");
					this.clickCount();
					app.animator.play(this.panel.countSymbol, ["idleToCount", "idle"]);
				}
			}.bind(this);
			
			if (this.character === 0) {
				voList.push("Countsheep_20");
				voList.push(app.hasTouch === true ? "Countsheep_26_Telly" : "Countsheep_24_Telly");
				app.animator.play(this.panel.tellySymbol, ["timeout1", "timeout2"]);
				app.voPlayer.play(voList);
			} else {
				var main = Math.floor(Math.random() * 3) + 1;
				voList.push("Countsheep_to" + main);
				if (main % 2 == 1) {
					voList.push(app.hasTouch === true ? 
						this.panel.countAnimations.mobile1[Math.floor(Math.random() * 3)] : 
						"Countsheep_18");
				} else {
					voList.push(app.hasTouch === true ? 
						this.panel.countAnimations.mobile2[Math.floor(Math.random() * 1)] : 
						this.panel.countAnimations.desktop2[Math.floor(Math.random() * 1)]);
				}
				this.panel.initializeCount("timeout");
				app.animator.play(this.panel.countSymbol, "timeout" + main, callback);
				app.voPlayer.play(voList, function(){
					app.state.startTimeout(false);
				});
			}

			this.character = Math.floor(Math.random() * 3);
			this.time = 10000;
			// new date for TO ReEngage event
			if (this.timeoutStartTime < 0) {
				this.timeoutStartTime = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000);
			}

			if (this.autoTimeout) {
				GTM_obj.trackGTMEvent('gameTimeoutPlay');
			}
			this.autoTimeout = true;

			app.voPlayer.play(voList, function(){
				app.state.startTimeout(false);
			});
			
		}.bind(this)), this.time);
	};

	//Stops the timeout handler
	p.stopTimeout = function() {
		app.voPlayer.play("");
		if (this.timeout) {
			this.timeout.destroy();
		}
	};

	/**
	 * When the state starts to exit, before transition
	 * @method  exitStart
	 */
	p.exitStart = function()
	{
		this.stopTimeout();
	};

	//Assign to namespace
	namespace('CountMeToSheep').GameState = GameState;
}());